import { styled } from "@mui/system";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";
import { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";
import TabUnstyled, { tabUnstyledClasses } from "@mui/base/TabUnstyled";

export const Tab = styled(TabUnstyled)`
  font-family: sans-serif;
  cursor: pointer;
  font-size: 14px;
  min-width: 100px;
  background-color: white;
  padding: 8px 20px;
  border: none;
  text-align: center;
  display: flex;
  justify-content: start;
  color: grey;
  transition: ease-in-out 0.3s;

  &:hover {
    background-color: #f1f1f1;
    color: black;
  }

  &:focus {
    outline: 2px solid grey;
  }

  &.${tabUnstyledClasses.selected} {
    border-bottom: 3px solid black;
    margin-bottom: -2px;
    color: black;
    font-weight: bold;
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

export const TabsList = styled(TabsListUnstyled)`
  min-width: 320px;
  width: '100%';
  background: white;
  display: flex;
  align-items: center;
  align-content: space-between;
  border-bottom: 1px solid #f1f1f1;
`;
